import RenderTtml from './pages2/DetailedDescription/indexRender';

const routerConfig = [
  {
    path: '*',
    component: RenderTtml,
    exact: true,
  },
];

export default routerConfig;
